(function () {
  'use strict';

  /* ---------- Header: sticky shadow, mobile menu, blend with sections ---------- */
  var header = document.getElementById('SiteHeader');
  if (header) {
    var onScroll = function () {
      header.classList.toggle('is-scrolled', window.scrollY > 8);
    };
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });

    var toggle = header.querySelector('[data-menu-toggle]');
    var mobile = header.querySelector('[data-mobile-nav]');
    if (toggle && mobile) {
      toggle.addEventListener('click', function () {
        var open = toggle.getAttribute('aria-expanded') === 'true';
        toggle.setAttribute('aria-expanded', String(!open));
        mobile.hidden = open;
        header.classList.toggle('menu-open', !open);
      });
      mobile.querySelectorAll('a').forEach(function (a) {
        a.addEventListener('click', function () {
          toggle.setAttribute('aria-expanded', 'false');
          mobile.hidden = true;
          header.classList.remove('menu-open');
        });
      });
    }

    /* Blend the header colours with whichever section sits underneath it. */
    if (header.dataset.blend === 'true' && 'IntersectionObserver' in window) {
      var bands = document.querySelectorAll('[data-theme-bg]');
      var apply = function (el) {
        header.style.setProperty('--header-bg', el.dataset.themeBg);
        if (el.dataset.themeInk) header.style.setProperty('--header-ink', el.dataset.themeInk);
      };
      var headerHeight = header.offsetHeight || 96;
      var observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) apply(entry.target);
        });
      }, { rootMargin: '-' + headerHeight + 'px 0px -' + Math.max(window.innerHeight - headerHeight - 1, 0) + 'px 0px', threshold: 0 });
      bands.forEach(function (b) { observer.observe(b); });
    }
  }

  /* ---------- FAQ: only one open at a time ---------- */
  document.querySelectorAll('[data-faq]').forEach(function (group) {
    var items = group.querySelectorAll('details');
    items.forEach(function (item) {
      item.addEventListener('toggle', function () {
        if (!item.open) return;
        items.forEach(function (other) { if (other !== item) other.open = false; });
      });
    });
  });

  /* ---------- Buy form: variant price sync ---------- */
  document.querySelectorAll('[data-product-form]').forEach(function (form) {
    var select = form.querySelector('select[name="id"]');
    var priceEl = form.closest('[data-buy]') && form.closest('[data-buy]').querySelector('[data-price]');
    var button = form.querySelector('[data-add-button]');
    if (!select) return;
    select.addEventListener('change', function () {
      var opt = select.options[select.selectedIndex];
      if (priceEl && opt.dataset.price) priceEl.textContent = opt.dataset.price;
      if (button) {
        var available = opt.dataset.available === 'true';
        button.disabled = !available;
        button.textContent = available ? button.dataset.labelAdd : button.dataset.labelSoldOut;
      }
    });
  });
})();
